import React from 'react';

import { Button } from '@/components/ui/button';
import { HorizontalLayout, Title } from 'widgets';

interface Props {
    title: string;
    buttonLabel: string;
    onClick: () => void;
}

export const TimelineHeader = ({ title, buttonLabel, onClick }: Props) => {
    return (
        <HorizontalLayout $apart $rowCenter $margin="0 0 24px 0">
            <Title content>{title}</Title>
            <Button onClick={onClick}>{buttonLabel}</Button>
        </HorizontalLayout>
    );
};
